import { useEffect, useState } from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { Link2, CheckCircle2, AlertCircle } from "lucide-react";

export function QuickBooksConnectCard({ orgId }: { orgId: string }) {
  const [connection, setConnection] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const { data } = await supabase
        .from("quickbooks_connections")
        .select("*")
        .eq("org_id", orgId)
        .maybeSingle();
      setConnection(data);
      setLoading(false);
    })();
  }, [orgId]);

  const startOAuth = () => {
    toast.info("QuickBooks OAuth will be wired in once you add Intuit app credentials. Backend tables and sync log are ready.");
  };

  return (
    <Card className="p-6">
      <div className="flex items-start justify-between gap-4">
        <div className="flex items-start gap-3">
          <div className="p-2 rounded-lg bg-primary/10">
            <Link2 className="w-5 h-5 text-primary" />
          </div>
          <div>
            <h3 className="text-lg font-semibold flex items-center gap-2">
              QuickBooks Online
              {connection?.status === "active" && (
                <Badge className="bg-green-500/15 text-green-600 hover:bg-green-500/20">
                  <CheckCircle2 className="w-3 h-3 mr-1" />Connected
                </Badge>
              )}
              {connection?.status === "expired" && (
                <Badge variant="destructive">
                  <AlertCircle className="w-3 h-3 mr-1" />Expired
                </Badge>
              )}
            </h3>
            <p className="text-sm text-muted-foreground mt-1">
              {connection
                ? `Realm ${connection.realm_id} · last sync ${connection.last_sync_at ? new Date(connection.last_sync_at).toLocaleString() : "never"}`
                : "Two-way sync of customers, invoices, payments, and expenses."}
            </p>
          </div>
        </div>
        <Button onClick={startOAuth} disabled={loading}>
          {connection ? "Sync now" : "Connect"}
        </Button>
      </div>
    </Card>
  );
}
